import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./AuthSlice/AuthSlice";
import switchReducer from "./SwitchSlice";
import modalReducer from "./modalSlice";
import usersReducer from "./UserSlice/UserSlice";
import panelsReducer from "./PanlesSlice/PanelsSlice";
import panelReducer from "./PanlesSlice/SinglePanelSlice";
import utilityReducer from "./UtilityProviders/UtilitySlice";
import statesReducer from "./StateSlice/stateSlice";
import leadsReducer from "./LeadsSlice/LeadsSlice";
import rolesReducer from "./RolesSlice/RolesSlice";
import BusReducer from "./BusSlice/BusSlice";
import InstalleReducer from "./InstallerSlice/InstallerSlice";
import SaveSlice from "./SaveObjToUpdate/SaveSlice";
import SolarReducer from "./SolarContracts/SolarSlice";
import VendorSlice from "./VendorSlice/VendorSlice";
import ContractorSlice from "./ContractorSlice/ContractorSlice";
import DesignerSlice from "./DesignerSlice/DesignerSlice";
import MaliSlice from "./MailSlice/MaliSlice";
import LicensSlice from "./DesignerSlice/LicensSlice/LicensSlice";
import CardSlice from "./Analysis/AnalysisSlice";
import SolutionsSlice from "./Solutions/SolutionsSlice";
import EverSignDocumentsSlice from "./EverSignDocumentsSlice/EverSignDocumentsSlice";
import AddersSlice from "./AddersSlice/AddersSlice";
import AddersCategoriesSlice from "./AddersCategoriesSlice/AddersCategoriesSlice";
import AddersSlicev2 from "./AddersSlicev2/AddersSlicev2";
import MessagesSlice from "./MessagesSlice/MessagesSlice";
import SunlightRates from "../Pages/SunlightRates/SunlightRates";
import SunlightRatesSlice from "./Finance/SunlightRates/SunlightRatesSlice";
import PusherSlice from "./PusherSlice/PusherSlice";
import ApcAdderSlice from "./APCAdder/ApcAdderSlice";
import TicketsSlice from "./TicketsSlice/TicketsSlice";
export const store = configureStore({
    reducer: {
        auth: authReducer,
        switch: switchReducer,
        modal: modalReducer,
        users: usersReducer,
        panels: panelsReducer,
        panel: panelReducer,
        utility_providers: utilityReducer,
        AllStates: statesReducer,
        leads: leadsReducer,
        save: SaveSlice,
        contract: SolarReducer,
        roles: rolesReducer,
        business: BusReducer,
        installer: InstalleReducer,
        vendors: VendorSlice,
        contractors: ContractorSlice,
        designers: DesignerSlice,
        mails: MaliSlice,
        designer_licens: LicensSlice,
        cards: CardSlice,
        solutions: SolutionsSlice,
        eversign_documents: EverSignDocumentsSlice,
        adders: AddersSlice,
        adders_categories: AddersCategoriesSlice,
        addersv2: AddersSlicev2,
        messages: MessagesSlice,
        sunlight_rates: SunlightRatesSlice,
        pusher: PusherSlice,
        apc_adders: ApcAdderSlice,
        tickets : TicketsSlice,
    },
});
